import Papa from 'papaparse';
import type { ScoredGeography } from '@/types/insights';
import { round } from '@/utils/numbers';
import { downloadBlob } from './download';

/**
 * Exports the current geography set to CSV entirely client-side via a Blob
 * URL -- no backend involved, per the no-backend constraint.
 */
export function exportGeographiesToCsv(geographies: ScoredGeography[], filename = 'texas-market-map-export.csv') {
  const rows = geographies.map(({ record, insights }) => ({
    geo_id: record.geoId,
    geo_name: record.geoName,
    period: record.periodLabel,
    contributing_sources: insights.contributingSources.join('; '),
    is_sample_data: insights.isSampleData,
    median_sale_price: record.resolved.medianSalePrice ?? '',
    median_days_on_market: record.resolved.medianDaysOnMarket ?? '',
    months_of_inventory: record.resolved.monthsOfInventory ?? '',
    sale_to_list_ratio_pct: record.resolved.saleToListRatioPct ?? '',
    price_reduction_share_pct: record.resolved.priceReductionSharePct ?? '',
    hot_cold_score: round(insights.hotColdScore.value, 1),
    hot_cold_label: insights.hotColdScore.label,
    sell_speed_shift: round(insights.sellSpeedShift.value, 1),
    inventory_pressure: round(insights.inventoryPressure.value, 1),
    opportunity_score: round(insights.opportunityScore.value, 1),
    cooling_risk: round(insights.coolingRisk.value, 1),
    buyer_competition: round(insights.buyerCompetition.value, 1),
    confidence_score: round(insights.confidenceScore.value, 1),
    top_explanation: insights.explanations[0] ?? '',
  }));

  const csv = Papa.unparse(rows);
  downloadBlob(csv, filename, 'text/csv;charset=utf-8');
}
